import { PageTypeEnum } from '@/constant';
import { TDefineDocumentAreaDetailStore } from '@/stores';
import { convertDocumentTypeToName, convertFileType } from '@/utils';

import { isNonEmptyArray } from 'ramda-adjunct';

import RelationDocumentMobile from './relation-document';

export const getColumns = (
	content: TDefineDocumentAreaDetailStore[],
	pageType: PageTypeEnum
) => {
	if (!isNonEmptyArray(content)) return [];
	return content?.map((item) => ({
		id: {
			value: item?.id,
			className: 'w-max mr-2 text-spanishGray',
			label: 'ID. ',
		},
		registDt: {
			value: item.registDt,
			className: 'float-right mt-[0.556vw] text-spanishGray',
		},
		fileName: {
			value: item?.name,
			className: '!block !text-[15px] font-semibold !text-font2',
		},
		fileDocumentType: {
			value: convertDocumentTypeToName(item?.documentType),
			className: '!block',
		},
		fileType: {
			value: convertFileType(item?.type),
			className: '!block',
			label: '파일 유형: ',
		},
		other: {
			value: <RelationDocumentMobile record={item} pageType={pageType} />,
			className: '!block',
			label: '연관 정보: ',
		},
	}));
};
